import script from "./BulkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkPage.vue?vue&type=script&setup=true&lang=js"

import "./BulkPage.vue?vue&type=style&index=0&id=4413931c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4413931c"]])

export default __exports__